export const createBrainTreeClient = (authorization: string) =>
  new Promise((resolve, reject) => {
    if (!window.braintree) reject('createBrainTreeClient: Braintree SDK is not loaded.');

    window.braintree.client.create(
      { authorization },
      (error: Error | undefined, instance: unknown) =>
        error ? reject(new Error(`Error creating Braintree client: ${error}`)) : resolve(instance)
    );
  });
